import * as yup from 'yup';

declare module 'yup' {
  interface StringSchema<TType> {
    /**
     * Rende il campo nullabile e notRequired, però non modifica il tipo in "null".
     * Evita gli errori con le API generate automaticamente che generano null ma il tipo
     * delle richieste non li prevede.
     */
    allowNullable(options?: {
      alwaysUndefined?: boolean;
    }): StringSchema<TType | undefined>;
  }

  interface NumberSchema<TType> {
    /**
     * Rende il campo nullabile e notRequired, però non modifica il tipo in "null".
     * Evita gli errori con le API generate automaticamente che generano null ma il tipo
     * delle richieste non li prevede.
     */
    allowNullable(options?: {
      alwaysUndefined?: boolean;
    }): NumberSchema<TType | undefined>;
  }

  interface ArraySchema<TIn, TContext, TDefault, TFlags> {
    /**
     * Rende il campo nullabile e notRequired, però non modifica il tipo in "null".
     * Evita gli errori con le API generate automaticamente che generano null ma il tipo
     * delle richieste non li prevede.
     */
    allowNullable(options?: { alwaysUndefined?: boolean }): any;
  }

  interface BooleanSchema<TType> {
    /**
     * Rende il campo nullabile e notRequired, però non modifica il tipo in "null".
     * Evita gli errori con le API generate automaticamente che generano null ma il tipo
     * delle richieste non li prevede.
     */
    allowNullable(options?: {
      alwaysUndefined?: boolean;
    }): BooleanSchema<TType | undefined>;
  }

  interface DateSchema<TType> {
    /**
     * Rende il campo nullabile e notRequired, però non modifica il tipo in "null".
     * Evita gli errori con le API generate automaticamente che generano null ma il tipo
     * delle richieste non li prevede.
     */
    allowNullable(options?: {
      alwaysUndefined?: boolean;
    }): DateSchema<TType | undefined>;
  }
}

yup.addMethod<yup.StringSchema<string | undefined>>(
  yup.string,
  'allowNullable',
  function (
    this: yup.StringSchema<string | undefined>,
    options?: { alwaysUndefined?: boolean },
  ) {
    return this.notRequired()
      .nullable()
      .transform((v: any) =>
        options?.alwaysUndefined && !v ? undefined : v,
      ) as yup.StringSchema<string | undefined>;
  },
);

yup.addMethod<yup.NumberSchema<number | undefined>>(
  yup.number,
  'allowNullable',
  function (
    this: yup.NumberSchema<number | undefined>,
    options?: { alwaysUndefined?: boolean },
  ) {
    return this.notRequired()
      .nullable()
      .transform((v: any) =>
        options?.alwaysUndefined && !v ? undefined : v,
      ) as yup.NumberSchema<number | undefined>;
  },
);

yup.addMethod(
  yup.array,
  'allowNullable',
  function (this: any, options?: { alwaysUndefined?: boolean }) {
    return this.notRequired()
      .nullable()
      .transform((v: any) => (options?.alwaysUndefined && !v ? undefined : v));
  },
);

yup.addMethod<yup.BooleanSchema<boolean | undefined>>(
  yup.boolean,
  'allowNullable',
  function (
    this: yup.BooleanSchema<boolean | undefined>,
    options?: { alwaysUndefined?: boolean },
  ) {
    return this.notRequired()
      .nullable()
      .transform((v: any) =>
        options?.alwaysUndefined && v === null ? undefined : v,
      ) as yup.BooleanSchema<boolean | undefined>;
  },
);

yup.addMethod<yup.DateSchema<Date | undefined>>(
  yup.date,
  'allowNullable',
  function (
    this: yup.DateSchema<Date | undefined>,
    options?: { alwaysUndefined?: boolean },
  ) {
    return this.notRequired()
      .nullable()
      .transform((v: any) =>
        options?.alwaysUndefined && v === null ? undefined : v,
      ) as yup.DateSchema<Date | undefined>;
  },
);
